import {Component, Output, EventEmitter, OnChanges, Input} from '@angular/core';

import { Rule } from '../services/capd.model';
import { RulesService } from '../services/rules.service';

@Component({
  selector: 'rule-trigger-edit',
  templateUrl: './rule-trigger-edit.component.html',
  // inputs: [ 'selectedRule' ]
})

/**
 * Component for editing a rule's trigger code.
 */
export class RuleTriggerEditComponent implements OnChanges {
  @Output() triggerEdited = new EventEmitter();
  @Input() selectedRule: Rule;
  newTrigger = '';
  oldId = '';
  triggerValid = false;

  constructor(private _service: RulesService) { }

  /**
   * When a new rule is selected, copy the old trigger to edit.
   *
   * @func ngOnChanges
   */
  ngOnChanges() {
    this.newTrigger = this.selectedRule.triggerCode;
    this.oldId = '';
  }

  /**
   * Checks to see if the new trigger is nonzero and different from the previous version.
   *
   * @func isValid
   */
  isValid() {
    this.triggerValid = !(this.selectedRule.triggerCode === this.newTrigger) && this.newTrigger.length > 0;
  }

  /**
   * Submits the changes to the server.
   *
   * @async
   * @func onSubmit
   */
  onSubmit() {
    this.selectedRule.triggerCode = this.newTrigger;
    this.oldId = this.selectedRule._id;
    this.selectedRule._id = '';

    this._service.deleteRule(this.oldId).then(() => {
      this._service.addRule(this.selectedRule).then(newTrigger => {
        this.triggerEdited.emit(newTrigger);
      });
    });
  }

  /**
   * Cancels the action, resetting the trigger code input.
   *
   * @func onCancel
   */
  onCancel() {
    this.newTrigger = this.selectedRule.triggerCode;
    this.oldId = '';
  }

}
